<template>
  <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
    <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
      <v-data-table :headers="headers" :items="dashboardibrequest?.allPendingIBrequest || []" :loading="isLoading"
        hide-default-footer>
        <template v-slot:loading>
          <div class="d-flex align-center justify-center pa-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <span class="ml-2">Loading data...</span>
          </div>
        </template>
        <template v-slot:no-data>
          <div class="d-flex align-center justify-center pa-4">
            <v-icon color="secondary">mdi-information</v-icon>
            <span class="ml-2">No data found</span>
          </div>
        </template>
        <template v-slot:no-results>
          <div class="d-flex align-center justify-center pa-4">
            <v-icon color="secondary">mdi-magnify</v-icon>
            <span class="ml-2">No matching data found</span>
          </div>
        </template>

        <template v-slot:item.admin_name="{ item }">
          {{ item?.admin_name || "N/A" }}
        </template>

        <template v-slot:item.mobile="{ item }">
          {{ item?.mobile || "N/A" }}
        </template>

        <template v-slot:item.countries="{ item }">
          {{ item?.countries?.name || "N/A" }}
        </template>

        <template v-slot:item.email="{ item }">
          <v-tooltip top color="#000">
            <template v-slot:activator="{ on }">
              <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                {{ obfuscateAnyEmail(item?.email) }}
                <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                  {{
                    copiedStates[item.id]
                      ? "mdi mdi-check"
                      : "mdi-content-copy"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{ item?.email || "N/A" }}</span>
          </v-tooltip>
        </template>

        <template v-slot:item.fullname="{ item }">
          <router-link v-if="$canRoute('partner-list') === 1" class="text-capitalize text--ash" :to="`/registered-user-details/${item.id}`">
            {{ item.fullname }}
          </router-link>
          <span v-else class="text-capitalize text--ash">{{ item.fullname }}</span>
        </template>
        
        <template v-slot:item.created_at="{ item }">
          {{ formatMySQLDate(item?.created_at || "N/A") }}
        </template>

        <template v-slot:item.status="{ item }">
          <div class="status-selection status-selection-blocked-user">
            <v-select :disabled="$canRoute('partner-list') !== 1" solo :items="ibStatus" append-icon="mdi-chevron-down" class="custom-select"
              v-model="statusMap[item.id]" item-text="text" item-value="value" hide-details
              @change="handleStatusChange(item.id, statusMap[item.id])">
              <template v-slot:selection="{ item }">
                <div :class="getTextColor(item)">
                  {{ item.text || "N/A" }}
                </div>
              </template>
            </v-select>
          </div>
        </template>

        <template v-slot:item.details="{ item }">
          <router-link class="links text-decoration-none" :to="`/registered-user-details/${item?.id}`">
            <v-icon color="#039de9" small>
              mdi-eye-outline
            </v-icon>
          </router-link>
        </template>
      </v-data-table>
    </v-sheet>
  </v-card>
</template>

<script>
import { formatMySQLDate } from "@/_helpers/formateDate";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import { IBREQUEST__ACTIONS, PARTNERLIST__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      isLoading: false,
      statusMap: {},
      isCopied: false,
      copiedStates: {},
      ibStatus: [
        { text: "Approve", value: "Approve", class: "text-approved" },
        { text: "Pending", value: "Pending", class: "text-pending" },
        { text: "Decline", value: "Decline", class: "text-decline" },
      ],
      headers: [
        { text: "Name", value: "fullname" },
        { text: "Email", value: "email" },
        { text: "Country", value: "countries" },
        { text: "Mobile No.", value: "mobile" },
        { text: "Reg. Time", value: "created_at" },
        { text: "Action By", value: "admin_name" },
        { text: "IB Status", value: "status" },
      ]
    };
  },
  computed: {
    ...mapState("partnerlist", ['dashboardibrequest'])
  },

  methods: {
    formatMySQLDate,
    ...mapActions("ibrequest", [
      IBREQUEST__ACTIONS.UPDATEIBREQ
    ]),
    ...mapActions("partnerlist", [
      PARTNERLIST__ACTIONS.DASHBOARDIBREQUEST
    ]),

    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },
    copyText(item) {
      navigator.clipboard.writeText(item?.email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },

    getTextColor(item) {
      return item.class;
    },

    async handleStatusChange(itemId, newStatus) {
      try {
        await this[IBREQUEST__ACTIONS.UPDATEIBREQ]({
          client_id: itemId,
          new_status: newStatus === 'Approve' ? 1 : newStatus === 'Decline' ? 3 : 2
        });

        setTimeout(() => {
          this[PARTNERLIST__ACTIONS.DASHBOARDIBREQUEST]()
        }, 1000)
        this.initializeStatusMap();
      } catch (error) {
        console.error('Error updating status:', error);
      }
    },
    async fetchData() {
      try {
        this.isLoading = true;
        await this[PARTNERLIST__ACTIONS.DASHBOARDIBREQUEST]();
        this.initializeStatusMap();
      } catch (error) {
        console.error('Error fetching dashboard IB requests:', error);
      } finally {
        this.isLoading = false;
      }
    },
    initializeStatusMap() {
      if (this.dashboardibrequest?.allPendingIBrequest) {
        this.dashboardibrequest.allPendingIBrequest.forEach(item => {
          let status = "Pending";
          if (item.ib_status === 1) status = "Approve";
          else if (item.ib_status === 3) status = "Decline";

          this.$set(this.statusMap, item.id, status);
        });
      }
    }
  },

  async created() {
    await this.fetchData();
    if (this.$canRoute('partner-list') === 1) {
      this.headers.push({ text: "Details", value: "details" });
    }
  },
};
</script>